import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { AlertCircle, Loader2 } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_44ec93c6-a1ed-4add-8620-bb53ad1de93f/artifacts/fo7gzvnl_2.png";
const BG_IMAGE = "https://customer-assets.emergentagent.com/job_grit-core/artifacts/n6bkaa2s_DSC07097_1_b1609514-6f8d-40a7-b37d-d7447e84e089.jpg";

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="login-container" data-testid="login-page">
      {/* Form Side */}
      <div className="login-form-side">
        <div className="max-w-md mx-auto w-full">
          {/* Logo */}
          <div className="mb-12">
            <img 
              src={LOGO_URL} 
              alt="GRIT Studio" 
              className="h-16"
              data-testid="login-logo"
            />
          </div>

          {/* Welcome Text */}
          <div className="mb-8">
            <h1 className="text-3xl font-semibold text-[#1A2835] tracking-tight font-['Outfit']">
              Bienvenido
            </h1>
            <p className="text-[#5C7083] mt-2">
              Sistema de Gestión Interno
            </p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
            {error && (
              <div className="alert-card alert-error animate-fade-in" data-testid="login-error">
                <AlertCircle size={20} />
                <span>{error}</span>
              </div>
            )}

            <div className="space-y-2">
              <Label htmlFor="email" className="form-label">
                Correo Electrónico
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="correo@gritstudio.cl"
                className="form-input"
                required
                data-testid="input-email"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="form-label">
                Contraseña
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="form-input"
                required
                data-testid="input-password"
              />
            </div>

            <Button
              type="submit"
              className="w-full btn-primary h-12 text-base"
              disabled={loading}
              data-testid="btn-login"
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                  Ingresando...
                </>
              ) : (
                'Ingresar'
              )}
            </Button>
          </form>
        </div>
      </div>

      {/* Image Side */}
      <div 
        className="login-image-side"
        style={{ backgroundImage: `url(${BG_IMAGE})` }}
        data-testid="login-image"
      />
    </div>
  );
};

export default Login;
